export enum VerificationTypeEnum {
  SIGNUP = "signup",
  SIGNIN = "signin",
  RESET_PASSWORD = "reset_password",
}
